export const ETP_RESET = "ETP_RESET";
export const ETP_SET_ERROR = "ETP_SET_ERROR";
export const ETP_SET_ITEMS = "ETP_SET_ITEMS";
export const ETP_TOGGLE_LOADING = "ETP_TOGGLE_LOADING";
